import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../icon';

const TagDeleteButton = (props) => {
  const {
    selectProps: { isDisabled },
    innerProps: { ref, ...restInnerProps },
  } = props;

  return (
    <button
      {...restInnerProps}
      ref={ref}
      className="ws-ui-tag-input-tag-delete-button"
      disabled={isDisabled}
    >
      <Icon type="inherit" size="100%" glyph="clear-search" />
    </button>
  );
};

TagDeleteButton.propTypes = {
  selectProps: PropTypes.shape({
    isDisabled: PropTypes.bool.isRequired,
  }).isRequired,
  innerProps: PropTypes.shape({
    ref: PropTypes.any,
  }).isRequired,
};

export default TagDeleteButton;
